import { AlertBannerStatus, CopyButtonWithTooltip } from '@tryhackme/thm-ui-components';
import { StyledCredential, StyledCredentialField, StyledCredentials, StyledCredentialsAlert } from '../azure-cloud-details-modal.styles';
import { AzureSectionProps } from '../azure-cloud-details-modal.types';
export const AzureCredentials = ({
  lab,
  formattedExpiry
}: AzureSectionProps) => lab && formattedExpiry !== null ? <StyledCredentials data-testid="azure-credentials">
      <StyledCredential>
        <StyledCredentialField>Lab ID:</StyledCredentialField>
        <div>{lab?.labId}</div>
        {lab?.labId && <CopyButtonWithTooltip value={lab?.labId} />}
      </StyledCredential>
      <StyledCredential>
        <StyledCredentialField>Username:</StyledCredentialField>
        <div>{lab?.username}</div>
        {lab?.username && <CopyButtonWithTooltip value={lab?.username} />}
      </StyledCredential>
      <StyledCredential>
        <StyledCredentialField>Password:</StyledCredentialField>
        <div>{'*'.repeat(lab?.password.length)}</div>
        {lab?.password && <CopyButtonWithTooltip value={lab?.password} />}
      </StyledCredential>
    </StyledCredentials> : <StyledCredentialsAlert status={AlertBannerStatus.WARNING} message="Join lab to access credentials" />;